// "1 message", "1,204 messages": the count is localised, the noun takes a plain "s".
export function plural(count: number, noun: string): string {
    return `${count.toLocaleString()} ${noun}${count === 1 ? '' : 's'}`;
}
